import { render, staticRenderFns } from "./ForgotPasswordEmail.vue?vue&type=template&id=7b0a2b3e&scoped=true&"
import script from "./ForgotPasswordEmail.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordEmail.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordEmail.vue?vue&type=style&index=0&id=7b0a2b3e&prod&lang=css&"
import style1 from "./ForgotPasswordEmail.vue?vue&type=style&index=1&id=7b0a2b3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0a2b3e",
  null
  
)

export default component.exports